import { Box, Stack, Typography } from "@mui/material";
import { useAskQuestionStore } from "../../../store/home/useAskQuestionStore";
import QuestionInput from "./QuestionInput";
import SampleQuestions from "./SampleQuestions";
import { useSearchParams } from "react-router-dom";
import { QuestionTargetSalesData } from "../state/DeepchatState";
import { useHydrateAtoms } from "jotai/utils";
import DeepchatNavigationTabs from "../DeepchatNavigationTabs";
import { Feature } from "../../../featureFlags/featureFlagConfig";
import useFeatureFlag from "../../../featureFlags/useFeatureFlag";

export default function AskQuestion() {
  const [searchParams] = useSearchParams();
  const salesdata = Boolean(searchParams.get("salesdata"));
  useHydrateAtoms([[QuestionTargetSalesData, salesdata ?? false]]);

  const document_summary = useFeatureFlag(Feature.DocumentSummary);
  useAskQuestionStore();

  return (
    <Box minHeight="100%" width="100%" maxWidth="48rem">
      <Stack
        className="QuestionInput"
        direction="column"
        justifyContent="center"
        alignItems="center"
        spacing={4}
        sx={{ minHeight: "100%" }}
      >
        <Typography variant="h3" fontWeight="bold" color={"rgb(0, 48, 135)"}>
          Welcome
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
          {document_summary.enabled && <DeepchatNavigationTabs />}
          <QuestionInput />
        </Box>
        <SampleQuestions />
      </Stack>
    </Box>
  );
}
